import { ContainerModule, interfaces } from "inversify";
import * as Api from './api'
import { QuestionFactorySymbol, QuestionFactory,
         QuestionSolutionFactorySymbol, QuestionSolutionFactory } from "./api/question-factory";
import { QuestionOptionsFactorySymbol, QuestionOptionsFactory } from './question-options-factory'

export const questionPluginModule = new ContainerModule(bind => {
  bind<QuestionFactory<unknown, unknown, unknown, unknown>>(
    QuestionFactorySymbol).toFactory<Vue>((context: interfaces.Context) => {

      return (questionType: string, propsData: Api.QuestionComponentProps2<unknown, unknown, unknown>) => {

      if (context.container.isBoundNamed(Api.QuestionComponentPluginSymbol, questionType)) {
        const ComponentConstructor = context.container.getNamed<Api.QuestionComponentPlugin>(
          Api.QuestionComponentPluginSymbol,
          questionType);

        return new ComponentConstructor({ propsData });
      } else {
        throw new Error(`Coding error: Question component not found for type '${questionType}'.`)
      }
    };
  });

  bind<QuestionSolutionFactory<unknown, unknown>>(
    QuestionSolutionFactorySymbol).toFactory<Vue>((context: interfaces.Context) => {

      return (questionType: string, propsData: Api.QuestionSolutionProps2<unknown, unknown>) => {

      if (context.container.isBoundNamed(Api.QuestionSolutionPluginSymbol, questionType)) {
        const ComponentConstructor = context.container.getNamed<Api.QuestionSolutionPlugin>(
          Api.QuestionSolutionPluginSymbol,
          questionType);

        return new ComponentConstructor({ propsData });
      } else {
        throw new Error(`Coding error: Question solution component not found for type '${questionType}'.`)
      }
    };
  });

  bind<QuestionOptionsFactory<unknown>>(
    QuestionOptionsFactorySymbol).toFactory<Api.QuestionOptions<unknown>>(({ container }: interfaces.Context) => {

      return (questionType: string) => {

        if (!container.isBoundNamed(Api.QuestionOptionsPluginSymbol, questionType)) {
          return Api.defaultQuestionOptions()
        }

        const options: Api.QuestionOptions<unknown> = container.getNamed<Api.QuestionOptions<unknown>>(
          Api.QuestionOptionsPluginSymbol, questionType)

        return options
    };
  });
});
